"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _logger = require("@ori/logger");
var _FooterAppSkeleton = require("./FooterAppSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file */

const ErrorBoundary = ({
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
  areaName: "ErrorBoundary",
  fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FooterAppSkeleton.FooterAppSkeleton, {}),
  children: children
});
exports.ErrorBoundary = ErrorBoundary;